// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KMwM","rootMobile":"styles_rootMobile__35Qqw"};